import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import Arrow from '../navigation-arrow'
import styles from './navigation-item.css'

import NAV_ITEM_FRAGMENT from '../../../../graphql/fragments/nav-item.gql'

export default function NavigationItemButton({
  navItem,
  onToggleMenu,
  activeClassName,
  location,
  isExpanded,
  pathname,
  className,
  onClick,
  inDropdown,
  setIsExpanded,
  expandOnHover,
  expandOnArrow
}) {
  const { logoUrl, name, children } = navItem
  const isValidLogoUrl = /\.(jpg|jpeg|png|svg)$/i.test(logoUrl)

  const navLinkLogoClassName = isValidLogoUrl ? styles.navLinkLogo : null

  const navigationItemTextOrImage = () => {
    return isValidLogoUrl ? (
      <img className={styles.navItemLogo} src={logoUrl} alt={`logo for menu ${name}`} />
    ) : (
      <span>{name}</span>
    )
  }

  const sharedProps = {
    className: classNames(className, activeClassName, styles.navItemToggle, navLinkLogoClassName),
    onMouseEnter: () => expandOnHover && setIsExpanded?.(true)
  }

  if (children?.length) {
    if (expandOnArrow) {
      return (
        <div>
          <span
            {...sharedProps}
            onClick={() => (!expandOnHover ? onToggleMenu() : undefined)}
            data-e2e={`${name}-in-Hamburger-menu`}
          >
            <a onClick={onClick}>{navigationItemTextOrImage()}</a>
            {!inDropdown && <Arrow isExpanded={isExpanded} />}
          </span>
        </div>
      )
    }

    return (
      <a
        {...sharedProps}
        onClick={e => (!expandOnHover ? onToggleMenu() : onClick(e))}
        data-e2e={`nav-item-${name}`}
      >
        {navigationItemTextOrImage()}
        {!inDropdown && <Arrow isExpanded={isExpanded} />}
      </a>
    )
  }

  return (
    <Link
      className={classNames(className, activeClassName, styles.navItemLink, navLinkLogoClassName)}
      onClick={onClick}
      to={pathname}
      data-e2e={`nav-item-${name}`}
    >
      {navigationItemTextOrImage()}
    </Link>
  )
}

NavigationItemButton.propTypes = {
  navItem: propType(NAV_ITEM_FRAGMENT).isRequired,
  className: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggleMenu: PropTypes.func.isRequired,
  activeClassName: PropTypes.string,
  inDropdown: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  expandOnHover: PropTypes.bool,
  expandOnArrow: PropTypes.bool
}

NavigationItemButton.defaultProps = {
  activeClassName: '',
  inDropdown: false,
  setIsExpanded: () => {},
  expandOnHover: false,
  expandOnArrow: false
}
